import moengage from "@moengage/web-sdk";

const camelToSnake = (value = "") => value.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();
const spaceToSnake = (value = "") => value.replace(/\s+/g, "_");

export function trackEngagement(data, eventName) {
  const engagementProps = {};

  if (data) {
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        const normalizedKey = spaceToSnake(camelToSnake(key));
        engagementProps[normalizedKey] = data[key].toString();
      }
    });
  }

  moengage.track_event(eventName, engagementProps);
}

const AmplitudeHelper = {
  init: () => {
    // no-op: initialized from App bootstrap.
  },
  logEvent: async (eventName, data) => {
    trackEngagement(data, eventName);
  },
  setUserId: (userId, employerId) => {
    if (userId) moengage.add_unique_user_id(userId.toString());
    if (employerId) moengage.add_user_attribute("employer_id", employerId.toString());
  },
  setLocation: async (lat, lng) => {
    if (lat !== undefined && lat !== null) moengage.add_user_attribute("latitude", lat.toString());
    if (lng !== undefined && lng !== null) moengage.add_user_attribute("longitude", lng.toString());
  },
  setUserProperties: (data = {}) => {
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        const normalizedKey = spaceToSnake(camelToSnake(key));
        moengage.add_user_attribute(normalizedKey, data[key].toString());
      }
    });
  },
  clearUserProperties: () => {
    moengage.destroy_session();
  },
};

export default AmplitudeHelper;
